import * as React from 'react';
import cx from 'classnames';
import style from './InitialProject.css';
import {Form} from './Form';

export const InitialProjectContext = React.createContext('InitialProject');
import IconCancel from './cancel.inline.svg';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import {getScrollbarWidth} from '_utils';

export class InitialProject extends React.Component {
    constructor(props) {
        super(props);
        this._handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const scrollbarWidth = getScrollbarWidth();
        document.addEventListener('click', this._handleClick);
        document.documentElement.style.overflow = 'hidden';
        document.body.style = `overflow: hidden; width: calc(100% - ${scrollbarWidth}px);`;
        disableBodyScroll(this.node);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._handleClick);
        enableBodyScroll(this.node);
        setTimeout(() => {
            document.documentElement.style.overflow = 'auto';
            document.body.style.overflow = "auto";
            document.documentElement.removeAttribute('style');
            document.body.removeAttribute('style');
        });
    }

    handleClick(e) {
        if (!this.container.contains(e.target)) {
            this.props.onClose();
        }
    }

    handleSubmit = () => {
        this.props.onClose();
    };

    render() {
        return (
            <div ref={c => this.node = c} className={style.root}>
                <div ref={c => this.container = c} className={cx(style.content)}>
                    <button
                        className={cx(style.btnClose)}
                        onClick={this.props.onClose}>
                        <IconCancel className={cx(style.cancel)}/>
                    </button>
                    <header>
                        <h4 className={style.title}>Initial Project Screening |
                            BlockScience</h4>
                    </header>
                    <p>
                        Please fill out this form to&nbsp;the best of&nbsp;your knowledge. This form will help
                        BlockScience understand your vision of&nbsp;the project and your current progress. Please
                        do&nbsp;not close this form until you have completed and submitted, otherwise your answers will
                        not be&nbsp;saved.
                    </p>
                    <p className={style.hint}>Fields marked with an <i className={style.star}>*</i> are required</p>
                    <Form onSubmit={this.handleSubmit}/>
                </div>
            </div>
        );
    }
}